const POLICY_SEARCH_TYPES = {
  DB: 'DB',
  API_V1: 'API',
  API_V2: 'API_V2',
} as const;

export default POLICY_SEARCH_TYPES;
